import { FitnessLevel } from './user';

export const COMPLEXITY_LEVELS_ARR = Object.values(FitnessLevel);

export const DEFAULT_VOLUME = 0.4;
export const DEFAULT_BACKGROUND_VOLUME = 0.1;
export const VOLUME_KEY_IN_LS = 'workout-volume';

/** Audio load retry policy: 3 attempts in total, ~0.9 s of backoff, well inside the 5 s launch countdown. */
export const AUDIO_LOAD_RETRIES = 2;
export const AUDIO_LOAD_RETRY_DELAYS_MS = [300, 600];
